<custom-scroll class="file-explorer-scroll">
    <div class="file-explorer-component">
        <div class="file-explorer-component-wrapper">
            <div class="file-explorer-header-wrapper">
                <custom-breadcrumb
                    [breadcrumbItems]="breadcrumbItems"
                    (breadcrumbClick)="navigateToFolder($event)"
                ></custom-breadcrumb>
            </div>
            <div class="file-explorer-content-wrapper">
                <div class="file-explorer-content-header">
                    <div
                        [class.disabled]="(currentFolderDetails && !currentFolderDetails.parentId) || loading"
                        class="back-action"
                        (click)="gobackToParent()"
                    >
                        <i class="modus-icons i24" aria-hidden="true">arrow_back</i>
                        <span class="button-text"> {{ 'TC.Common.Back' | translate }}</span>
                    </div>
                </div>
                <div class="file-explorer-body" [style]="{ height: maxHeight }">
                    <loading class="loading-icon" *ngIf="loading"></loading>
                    <custom-scroll class="folder-list" *ngIf="!loading" [style]="{ maxHeight: maxHeight }">
                        <ul class="list-content">
                            <li
                                *ngFor="let item of currentfolderItems"
                                class="list-item"
                                (click)="item.type !== TCObjectType.FOLDER && selectFile(item, $event)"
                                (dblclick)="item.type === TCObjectType.FOLDER && openFolder(item)"
                            >
                                <div class="item-left-actions">
                                    <i class="modus-icons" *ngIf="item.type === TCObjectType.FOLDER" aria-hidden="true"
                                        >folder_closed</i
                                    >
                                    <gsp-checkbox
                                        *ngIf="item.type === TCObjectType.FILE"
                                        [value]="selectedFilesMap.has(item.id)"
                                        (ngModelChange)="selectFile(item, $event)"
                                        class="select-file-checkbox"
                                        id="select-file-{{ item.id }}"
                                    >
                                    </gsp-checkbox>
                                </div>
                                <div class="item-content">
                                    <div
                                        class="file-thumbnail"
                                        *ngIf="
                                            item.type === TCObjectType.FILE && item.thumbStatus === 'READY';
                                            else noThumb
                                        "
                                        [style.backgroundImage]="'url(' + item.thumbnailUrl + ')'"
                                    ></div>
                                    <ng-template #noThumb>
                                        <i
                                            class="modus-icons"
                                            *ngIf="item.type === TCObjectType.FILE"
                                            aria-hidden="true"
                                            >file</i
                                        >
                                    </ng-template>
                                    <div class="folder-name" [title]="item.name">
                                        {{ item.name }}
                                    </div>
                                </div>
                                <i
                                    *ngIf="item.type === TCObjectType.FOLDER"
                                    class="icon_line_chevron_right i24"
                                    [title]="'MapViewer.MoveWorkspace.FolderNavigation.Tooltip' | translate"
                                    (click)="openFolder(item)"
                                    height="24"
                                    width="24"
                                ></i>
                            </li>
                        </ul>
                    </custom-scroll>
                </div>
            </div>
        </div>
        <div class="file-summary" *ngIf="fileSummaryVisible">
            <file-explorer-summary
                [selectedFiles]="getSelectedFiles()"
                [height]="summaryHeight"
                (removeFile)="deselectFile($event)"
            ></file-explorer-summary>
        </div>
    </div>
</custom-scroll>
